import './ReviewsAndRatingsSubDetail.scss';
import React, { useMemo } from 'react';

interface ReviewsAndRatingsSubDetailProps {
	ratings?: number;
	count?: number;
	maxStars?: number;
}

export const ReviewsAndRatingsSubDetail: React.FC<ReviewsAndRatingsSubDetailProps> = ({
	ratings,
	count,
	maxStars = 5
}) => {
	const { fullStars, hasHalfStar } = useMemo(() => {
		const safeNum = Number.isFinite(ratings as number) ? (ratings as number) : 0;
		const clampedNum = Math.max(0, Math.min(maxStars, safeNum));
		const fullNum = Math.floor(clampedNum);
		const decimal = clampedNum - fullNum;
		const halfNum = decimal >= 0.25 && decimal < 0.75;
		return { clampedRating: clampedNum, fullStars: fullNum, hasHalfStar: halfNum };
	}, [ratings, maxStars]);

	const handleReviewsClick = () => {
		const el = document.getElementById('reviews-section');
		if (el) {
			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

	return (
		<div className='reviews-ratings-subdetail'>
			{Array.from({ length: maxStars }).map((_, i) => {
				const isFull = i < fullStars;
				const isHalf = hasHalfStar && i === fullStars;
				const iconClass = isFull
					? 'ri-star-fill icon'
					: isHalf
					? 'ri-star-half-line icon'
					: 'ri-star-line icon';

				return <i key={i} className={iconClass} aria-hidden='true' />;
			})}
			<span className='reviews-text' onClick={handleReviewsClick}>
				{count} reviews
			</span>
		</div>
	);
};
